if (!customElements.get('furlio-gallery-controls')) {
  customElements.define('furlio-gallery-controls', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-direction]');
        if (!button) return;
        const gallery = this.closest('media-gallery');
        const items = [...gallery.querySelectorAll('[data-media-id]')].filter(item => item.matches('li'));
        const active = items.findIndex(item => item.classList.contains('is-active'));
        const next = (active + Number(button.dataset.direction) + items.length) % items.length;
        gallery.setActiveMedia(items[next].dataset.mediaId, false);
      });
    }
  });
}

if (!customElements.get('furlio-product-tabs')) {
  customElements.define('furlio-product-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const tablist = this.querySelector('.furlio-brush__tabs');
      const tabs = [...tablist.querySelectorAll('button')];
      const panels = [...this.querySelectorAll('.furlio-brush__panel')];
      tablist.hidden = false;
      tablist.setAttribute('role', 'tablist');
      tablist.setAttribute('aria-label', 'About this product');
      const select = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        panels[index].tabIndex = 0;
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          select(next, true);
        });
      });
      select(0);
    }
  });
}
